module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/root-th-c184ab87d14af239ee33be1cd1e71d4b.svg";